import { cleanString, cleanStringRules, useIsMobile } from '@ab-core/functions';
import type { ProductDocument } from '@ab-core/graphql/dist';
import { Image } from '@ab-core/image';
import { Link } from '@ab-core/link';
import useText from '@ab-core/localization/src/useText';
import type { ModalType } from '@ab-core/modal';
import Modal from '@ab-core/modal';
import Spacer from '@ab-core/spacer';
import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import { CardInfo, Picture } from './styled';

type ContactPersonProps = Pick<ProductDocument, 'sku' | 'productName'> & Pick<ModalType, 'open' | 'onClose'>;

export const ContactPersonModal: FC<ContactPersonProps> = (props) => {
    const { open, onClose, sku = '', productName } = props;
    const isMobile = useIsMobile();

    const headline = useText('contactPerson.headline');
    const personText = useText('contactPerson.text');

    const departmentConsumers = useText('contactPerson.address1_department');
    const categoryConsumers = useText('contactPerson.address1_category');
    const telConsumers = useText('contactPerson.address1_tel');
    const eMailConsumers = useText('contactPerson.address1_email');

    const departmentBuildings = useText('contactPerson.address2_department');
    const categoryBuildings = useText('contactPerson.address2_category');
    const telBuildings = useText('contactPerson.address2_tel');
    const emailBuildings = useText('contactPerson.address2_email');

    const cleanTelConsumers = cleanString(telConsumers, [
        cleanStringRules.removeAllWhitespace,
        cleanStringRules.removeAllHyphens
    ]);
    const cleanTelBuildings = cleanString(telBuildings, [
        cleanStringRules.removeAllWhitespace,
        cleanStringRules.removeAllHyphens
    ]);

    const mailtoConsumers = `mailto:${eMailConsumers}?subject=Anfrage Vertragsartikel: ${sku} - ${productName}`;
    const mailtoBuildings = `mailto:${emailBuildings}?subject=Anfrage Vertragsartikel: ${sku} - ${productName}`;

    return (
        <Modal open={open} onClose={onClose} paddingRight={0} headerText={headline}>
            <Spacer size={'xs'} />
            <CardInfo>
                <Picture>
                    <Image
                        src="https://res.cloudinary.com/alexander-buerkle/image/upload/v1659680259/Ansprechpartner.png"
                        objectFit="COVER"
                    />
                </Picture>
                <div className="flex-direction-column">
                    {isMobile && <Spacer size={'sm'} />}
                    <Text content={personText} className="pb-small3" />
                    <Text type={FontTypes.Subtitle} content={departmentConsumers} />
                    <Text content={categoryConsumers} />
                    <Link to={`tel:${cleanTelConsumers}`}>{`Tel. : ${telConsumers}`}</Link>
                    <Link to={mailtoConsumers} className="text-color-primary">
                        {eMailConsumers}
                    </Link>
                    <Spacer size={'xs'} />
                    <Link to={'/promotion/vertragspartnerportal/'} className="pb-medium">
                        Zum Vertragspartnerportal
                    </Link>
                    <Text type={FontTypes.Subtitle} content={departmentBuildings} />
                    <Text content={categoryBuildings} />
                    <Link to={`tel:${cleanTelBuildings}`}>{`Tel. : ${telBuildings}`}</Link>
                    <Link to={mailtoBuildings} className="text-color-primary">
                        {emailBuildings}
                    </Link>
                </div>
            </CardInfo>
        </Modal>
    );
};
